import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({ providedIn: 'root' })
export class PrecreatedBabTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackShowMoreClick(expanded: boolean): void {
        const details = expanded ? 'show more' : 'show less';

        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betbuilder',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'build a bet market pod',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'not applicable',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'event details - main tab',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: details,
            [trackingConstants.COMPONENT_URL_CLICKED]: 'not applicable',
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackAddorEditClick(eventName: string, sportId: number, leagueId: number, buttonText: string, isCtaButton: boolean = false): void {
        const trackingDetails = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betbuilder',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'build a bet market pod',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'precreated build a bet',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: eventName,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: isCtaButton ? `${buttonText} cta` : buttonText,
            [trackingConstants.COMPONENT_URL_CLICKED]: 'not applicable',
            [trackingConstants.SPORT_ID]: sportId.toString(),
            [trackingConstants.SPORT_LEAGUE_ID]: leagueId.toString(),
        };
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingDetails);
    }

    trackOverlayLoad(eventName: string, sportId: number, leagueId: number): void {
        const trackingDetails = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betbuilder',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'build a bet market pod',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'precreated build a bet',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: eventName,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'precreated build a bet popup',
            [trackingConstants.COMPONENT_URL_CLICKED]: 'not applicable',
            [trackingConstants.SPORT_ID]: sportId.toString(),
            [trackingConstants.SPORT_LEAGUE_ID]: leagueId.toString(),
        };
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingDetails);
    }

    trackAddorEditButtonLoad(eventName: string, sportId: number, leagueId: number): void {
        const trackingDetails = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betbuilder',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'quick betslip',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'not applicable',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: eventName,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'precreated build a bet',
            [trackingConstants.COMPONENT_URL_CLICKED]: 'not applicable',
            [trackingConstants.SPORT_ID]: sportId.toString(),
            [trackingConstants.SPORT_LEAGUE_ID]: leagueId.toString(),
        };
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingDetails);
    }
}
